<template>
  <div>
    <div class="nav-vertical">
      <ul class="nav nav-tabs nav-left" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" v-bind:href="'#t2'+rowData.pespar_id+''" role="tab" data-toggle="tab">
            <span class="nav-link-in">
              Região
              <i class="fa fa-truck"></i>
            </span>
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" v-bind:href="'#t3'+rowData.pespar_id+''" role="tab" data-toggle="tab">
            <span class="nav-link-in">
              Municipio
              <i class="fa fa-home"></i>
            </span>
          </a>
        </li>
      </ul>

      <div class="tab-content">
        <div role="tabpanel" class="tab-pane fade in active show pt-1 border-color-detalhes-grey" v-bind:id="'t2'+rowData.pespar_id+''">
          <table class="table" id="mais">
            <thead>
            <tr>
              <th style="width: 20%">Região</th>
              <th style="width: 60%">Nome</th>
              <th style="width: 20%">Status</th>
            </tr>
            </thead>
            <tbody  v-for="item in rowData.pessoa_parceira_regiao">
              <tr class="bg-gray-light" style="display: table-row;">
                <td>
                  {{ item.regiao.cd }}
                </td>
                <td>
                  {{ item.regiao.descr }}
                </td>
                <td>
                  <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                  <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div><!--.tab-pane-->
        <div role="tabpanel" class="tab-pane fade in show pt-1 border-color-detalhes-grey" v-bind:id="'t3'+rowData.pespar_id+''">
          <table class="table" id="mais">
            <thead>
            <tr>
              <th style="width: 20%">IBGE</th>
              <th style="width: 30%">Municipio</th>
              <th style="width: 30%">Uf</th>
              <th style="width: 20%">Status</th>
            </tr>
            </thead>
            <tbody  v-for="item in rowData.pessoa_parceira_municipio">
            <tr class="bg-gray-light" style="display: table-row;">
              <td>
                {{ item.municipio.cd_ibge }}
              </td>
              <td>
                {{ item.municipio.nome }}
              </td>
              <td>
                {{ item.municipio.uf.cd }}
              </td>
              <td>
                <span class="badge badge-success" v-if="item.status.valor==1">{{ item.status.descr }}</span>
                <span class="badge badge-danger" v-if="item.status.valor==2">{{ item.status.descr }}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div><!--.tab-pane-->
      </div><!--.tab-content-->
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      helpForm: new Form({statusRecord: [], params: []}),
    }
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
}
</script>
